var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron_right_FILL0_wght400_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0928 9.97915L6.96777 5.85415L7.86361 4.95831L12.8844 9.97915L7.86361 15L6.96777 14.1041L11.0928 9.97915Z",
    fill: "#49454F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.1c219b313aa1b8bc0ba55ca615ab5ec0.svg";
export { ForwardRef as ReactComponent };